module.exports = __webpack_public_path__ + "img/logo-text.5e3c17c4.svg";